import { useReducer } from 'react';
import { ConstantValues } from '../extensions/constantEx'

export const AddressFormInitalState = {
    id: ConstantValues.DefaultContactAddressId,
    address: '',
    district: '',
    pincode: '',
    thaluk: '',
    panchayat: '',
    ward: 0
};

export const NewEmployeeFormInitalState = {
    id: 0,
    photo_id: 0,
    documents: [],
    removed_nurse_doc_ids: [],
    removed_doc_ids: [],
    address1: { ...AddressFormInitalState }
};

const EmployeeFormInitalState = {
    employeeFormValue: { ...NewEmployeeFormInitalState },
    selectedEmployeeJson: { ...NewEmployeeFormInitalState },
    employeeDocs: [],
    removedEmployeeDocIds: [],
    removedDocIds: []
};


export const EmployeeFormReducer = (state = EmployeeFormInitalState, action) => {
    switch (action.type) {

        case "SET_EMPLOYEE_FORM_VALUE":
            return {
                ...state,
                employeeFormValue: { ...action.payload.employeeFormValue }
            }

        case "SET_EMPLOYEE_DOCS":
            return {
                ...state,
                employeeDocs: action.payload.docs
            }

        case "SET_REMOVED_EMP_DOC_IDS":
            return {
                ...state,
                removedEmployeeDocIds: action.payload.empDocIds
            }

        case "SET_REMOVED_DOC_IDS":
            return {
                ...state,
                removedDocIds: action.payload.docIds
            }

        case "SET_SELECTED_EMPLOYEE_JSON":
            return {
                ...state,
                selectedEmployeeJson: { ...action.payload.empJson }
            }

        default:
            return { ...state };
    }

}

export const useEmployeeForm = () => {
    const [employeeFormState, dispatchEmployeeFormState] = useReducer(EmployeeFormReducer, EmployeeFormInitalState);

    const SetEmployeeFormValue = (fromValue) => {
        dispatchEmployeeFormState({
            type: "SET_EMPLOYEE_FORM_VALUE",
            payload: {
                employeeFormValue: fromValue
            }
        })
    }

    const SetEmployeeDocuments = (docs) => {
        dispatchEmployeeFormState({
            type: "SET_EMPLOYEE_DOCS",
            payload: {
                docs: docs
            }
        })
    }

    const SetRemovedEmpDocIds = (nurseDocIds) => {
        dispatchEmployeeFormState({
            type: "SET_REMOVED_EMPLOYEE_DOC_IDS",
            payload: {
                nurseDocIds: nurseDocIds
            }
        })
    }

    const SetRemovedDocIds = (docIds) => {
        dispatchEmployeeFormState({
            type: "SET_REMOVED_DOC_IDS",
            payload: {
                docIds: docIds
            }
        })
    }

    const SetSelectedEmployeeJson = (empJson) => {
        dispatchEmployeeFormState({
            type: "SET_SELECTED_EMPLOYEE_JSON",
            payload: {
                empJson: empJson
            }
        })
    }

    return {
        ...employeeFormState,
        SetEmployeeFormValue,
        SetEmployeeDocuments,
        SetRemovedDocIds,
        SetRemovedEmpDocIds,
        SetSelectedEmployeeJson
    }
}

